"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundNetProspect = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundNetProspect = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundNetProspect, _super);
    function FundNetProspect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '预估净值';
        _this.code = '106006';
        _this.desc = '预估净值';
        _this.requestParams = new zl_1.FundNetProspectRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundNetProspect;
}(service_1.BaseService));
exports.FundNetProspect = FundNetProspect;
//# sourceMappingURL=fundNetProspect.js.map